import { useAjax, useMzMutation } from "@bsm/component";

export const useCountSoldMutation = () => {
    const ajax = useAjax();
    return useMzMutation(async (id: number) =>
        ajax.send({
            type: "POST",
            content_type: "application/json",
            url: `project/missing/${id}/countSold`,
            data: {},
        })
    );
};